import {useEffect, useRef} from 'react'
import useScreenWidth from './useScreenWidth'

const useScreenWidthEffect = (
  effectFunction: (screenWidth: number | undefined) => void,
  dependencies: any
): void => {
  const screenWidth = useScreenWidth()

  const effectFunctionRef = useRef(effectFunction)

  useEffect(() => {
    effectFunctionRef.current = effectFunction
  }, [effectFunction])

  useEffect(() => {
    effectFunctionRef.current(screenWidth)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth, ...dependencies])
}

export default useScreenWidthEffect
